export default "/_next/static/media/account1.d513d9afa8f16fcbd89e3ad8b4b30a60.png";